module.exports = __webpack_public_path__ + "static/wish-you-were-here-1f8e0712b2f2d4e70100770fba24ca52.jpg";